import {Component, computed, input, output} from '@angular/core';
import {MatIcon} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {RouterLink} from '@angular/router';
import {MatIconModule} from '@angular/material/icon';

export type InfoCardType = 'INFO' | 'WARNING' | 'SUCCESS' | 'ERROR' | 'PRIMARY';
export type InfoCardVariant = 'NOTICE' | 'BANNER';
export type InfoCardSize = 'SMALL' | 'MEDIUM' | 'LARGE';

const DEFAULT_ICONS: Record<InfoCardType, string> = {
  INFO: 'info',
  WARNING: 'warning',
  SUCCESS: 'check_circle',
  ERROR: 'error',
  PRIMARY: 'lightbulb',
};


@Component({
  selector: 'app-info-card',
  imports: [
    MatIcon,
    MatButtonModule,
    MatIconModule,
    RouterLink,
  ],
  templateUrl: './info-card.component.html',
  styleUrl: './info-card.component.scss'
})
export class InfoCardComponent {
  title = input<string>();
  subtitle = input<string>();
  type = input<InfoCardType>('INFO');
  variant = input<InfoCardVariant>('BANNER');
  size = input<InfoCardSize>('MEDIUM');
  icon = input<string>();
  hasContent = input<boolean>(false);
  marginTop = input<boolean>(false);
  buttonText = input<string>();
  link = input<string>();
  buttonClicked = output<void>();

  resolvedIcon = computed(() => this.icon() ?? DEFAULT_ICONS[this.type()]);

  onButtonClick(): void {
    if (this.buttonText()) {
      this.buttonClicked.emit();
    }
  }

  className = computed(() =>
    ['info-card',
      this.variant().toLowerCase(),
      this.type().toLowerCase(),
      this.size().toLowerCase(),
      !this.title() ? 'no-title' : '',
      this.hasContent() ? 'has-content' : '',
      this.marginTop() ? 'margin-top' : '',
    ].filter(Boolean).join(' ')
  );
}
